// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Error'"></sub-header>

  <div class="alert alert--danger" ng-switch="\$ctrl.type">
    <span ng-switch-when="ACCESS">Access denied. </span>
    <span ng-switch-default>Error occurred while accessing the requested page.</span>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/error-page/error-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;